import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Webkorps-Website/src/components/pages/EventCESPage.jsx");
